<template>
  <div class="page-container">
    <div class="page-header">
      <div class="left">
        <img src="../common/images/qzCollege/logo.png" alt="">
      </div>
      <div class="page-links">
        <a>主页</a>
        <router-link :to="{name: 'attend'}" target="_blank">学校申请</router-link>
        <router-link :to="{name: 'contentIndex'}" target="_blank">测评系统</router-link>
        <router-link :to="{name: 'contentIndex'}" target="_blank">示范班课程</router-link>
      </div>
    </div>
    <div class="page-top-warp">
      <div class="left">
        <img src="../common/images/qzCollege/index_bg.png" alt="">
<!--        <h1 class="title">Welcome to</h1>-->
<!--        <h1 class="title">数学拔尖创新人才培养与测评</h1>-->
<!--        <p class="text_1">从“娃娃”抓起，用科学的方法尽早找到这些“数学苗子”</p>-->
<!--        <p class="text_2">Welcome to the Training and Assessment of Mathematical Top Innovative Talents</p>-->
        <div class="page_button">
          <router-link class="button-test"  :to="{name: 'contentIndex'}" target="_blank">前往测评</router-link>
          <a
            class="button-pdf"
            href="https://resource.du.youdao.com/%E6%B8%85%E5%8D%8E%E5%A4%A7%E5%AD%A6%E6%B1%82%E7%9C%9F%E4%B9%A6%E9%99%A2%E5%AE%A3%E4%BC%A0%E6%89%8B%E5%86%8C.pdf"
            download="清华大学求真书院宣传手册"
            target="_blank"
          >下载《清华大学求真书院宣传手册》</a>
        </div>
      </div>
      <div class="right">
        <img src="../common/images/qzCollege/top_img.png" alt="" data-aos="slide-left"
             data-aos-mirror="false"
             data-aos-duration="1000" data-aos-offset="50"/>
      </div>
    </div>
    <div class="page-content-1">
      <h1 data-aos="slide-down" data-aos-duration="500"
          class="page-title-1"
          data-aos-mirror="false"
          data-aos-anchor=".page-top-warp"
          data-aos-anchor-placement="top-center">数学拔尖创新人才培养与测评 | 培养下一代数学人才</h1>
      <div class="content-tag" data-aos="slide-down"></div>
      <div class="content">
        <div class="left" data-aos="fade-zoom-in" data-aos-delay="100">
          <img src="../common/images/qzCollege/content_1_img.png" alt="">
        </div>
        <div class="right" data-aos="fade-zoom-in"  data-aos-delay="200">
          <h3>清华大学数学科学中心</h3>
          <p>清华大学数学科学中心（简称“数学中心”）成立于 2009年12月, 特聘国际著名数学大师丘成桐先生担任中心主任。作为支持清华大学发展数学学科的重大战略举措，教育部于 2014 年底同意依托清华大学成立“丘成桐数学科学中心”。</p>
          <p>在丘成桐教授的带领下，数学中心在高端人才引进、杰出数学人才培养、高水平学术研究和数学学科建设方面取得了跨越式发展，已成为具有重要国际影响力的数学研究中心，将清华数学的发展带入前所未有的高度。</p>
          <p>截至 2025 年 5 月，数学中心共有全日制在校教师和科研人员 166 人，其中，包括 2 位菲尔兹奖得主、 4 位院士，建成以纯粹数学为核心的“五大领域”和“三个交叉研究方向”的综合性学科布局，共六大科研团队。代数与数论、数学物理以及动力系统与随机分析这三个科研团队，已达到世界顶尖水平。在QS世界大学数学学科排名中，清华数学学科从2009年中心初创时的第96名，跃升至2025年最新排名第11位，在全国高校中国际排名第一。</p>
        </div>
      </div>
    </div>
    <div class="page-content-2">
      <div class="content-tag" data-aos="slide-down"></div>
      <div class="content">
        <div class="left" data-aos="fade-zoom-in" data-aos-anchor=".page-content-2" data-aos-delay="100">
          <h3>北京雁栖湖应用数学研究院</h3>
          <p>北京雁栖湖应用数学研究院（以下简称“数学院”）成立于2020年6月，是由北京市与清华大学联合共建的世界一流新型研发机构。在市科委、中关村管委会的指导下，数学院充分依托清华大学相关优势学科，遵循“75%中上游应用数学、25%基础数学”的发展模式，瞄准国家在应用数学领域的重大需求和“卡脖子”问题，依托院长丘成桐先生的全球学术号召力，聘请国际和国内顶尖数学家组建科研团队和实验室，广泛探索科学前沿。</p>
        </div>
        <div class="right" data-aos="fade-zoom-in" data-aos-anchor=".page-content-2" data-aos-delay="200">
          <img src="../common/images/qzCollege/content_2_img.png" alt="">
        </div>
      </div>
    </div>
    <div class="page-content-3" v-if="courseData?.length > 0">
      <div class="course-list-warp">
        <h3 class="title">示范班课程</h3>
        <p class="desc">杰出少年示范数学班课程 免费学</p>
        <div class="course-list">
         <div class="prev" @click="prevCourse" :class="{ disabled: currentIndex === 0 }">
           <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
         </div>
          <div class="course-item-warp" ref="courseContainer">
            <a class="course-card-warp" v-for="course in courseData"
                :key="course.id"
                :href="`/courseDetail?libraryId=${course.bookLibraryId}`"
                 >
              <div class="course-card">
                <div class="free-tag"></div>
                <div class="card-content">
                  <div class="course-cover">
                    <img :src="course.cardImgUrl" class="fit-img"/>
                  </div>
                  <div class="course-info">
                    <h3 class="course-name" >{{ course.title }}</h3>
                    <p class="course-teacher">授课老师: {{ course.teacher }}</p>
                    <div class="card-footer">
                      <button class="view-course-btn">立即学习</button>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
         <div class="next" @click="nextCourse" :class="{ disabled: currentIndex >= courseData.length - 4 }">
           <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
           </svg>
         </div>
        </div>
      </div>
    </div>
    <div class="page-content-4">
      <div class="content">
        <img src="../common/images/qzCollege/content_3_img1.png" alt="" data-aos="flip-up" data-aos-delay="100">
        <img src="../common/images/qzCollege/content_3_img2.png" alt="" data-aos="flip-up" data-aos-delay="200">
        <img src="../common/images/qzCollege/content_3_img3.png" alt="" data-aos="flip-up" data-aos-delay="300">
        <img src="../common/images/qzCollege/content_3_img4.png" alt="" data-aos="flip-up" data-aos-delay="400">
        <img src="../common/images/qzCollege/content_3_img5.png" alt="" data-aos="flip-up" data-aos-delay="500">
        <img src="../common/images/qzCollege/content_3_img6.png" alt="" data-aos="flip-up" data-aos-delay="600">
      </div>
    </div>

    <div class="page-content-5" id="content5">
        <h3 class="title">精选真题</h3>
        <!-- 题目轮播 -->
        <div class="el-carousel-wrap">
          <question-card-swiper></question-card-swiper>
        </div>
        <a class="button" @click.stop="goQuestionList">了解更多</a>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import AOS from 'aos';
import { getUserLoginStatus, mathHomeUrl} from "@/api/api";
import {getContentList} from "@/api/courseData"
// import { Carousel, CarouselItem } from 'element-ui';
import QuestionCardSwiper from './student/components/questionCardSwiper.vue';
import PageFooter from '@/components/PageFooter.vue';
import { goLogin } from '@/common/js/util';

export default {
  name: 'homePage',
  components: {
    // QuestionCarousel,
    // 'el-carousel': Carousel,
    // 'el-carousel-item': CarouselItem,
    QuestionCardSwiper,
    PageFooter,
  },
  data() {
    return {
      courseData:[],
      currentIndex: 0,
      cardWidth: 310,
    }
  },
  created() {
    AOS.init({
      mirror:false,
      duration:1000
    });
    this.getCourseData();
  },
  methods: {
    prevCourse() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.scrollToIndex();
      }
    },
    goQuestionList() {
      const url = `${mathHomeUrl}exam/index.html#/questionListPage`;
      getUserLoginStatus().then(res => {
        if (res.body.login === true) {
          window.open(url, '_blank' );
        } else {
          goLogin(url)
        }
      }).catch(() => {
        // 无论如何都打开链接
        window.open(url, '_blank' );
      });
    },
    getCourseData() {
      getContentList().then(res => {
        if (res.code === 200 && res.body?.contents) {
          this.courseData = res.body.contents;
        }
      })
    },
    handleViewCourse(course){
      const {libraryId} = course;
      window.location.href = `${mathHomeUrl}courseDetail?libraryId=${libraryId}`;
    },
    nextCourse() {
      if (this.currentIndex < this.courseData.length - 4) { // 默认展示4个
        this.currentIndex++;
        this.scrollToIndex();

      }
    },
    scrollToIndex() {
      const container = this.$refs.courseContainer;
      if (container) {
        const width = container.offsetWidth;
        // 每次滚动一个卡片宽度（310px）
        const scrollLeft = this.currentIndex * width / 4;
        container.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<style scoped lang="less">
.page-container{
  width: 100%;
  height: 100%;
  // min-width: 1200px;
  position: relative;
  .page-header{
    width: 100%;
    height: 6.25vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    position: relative;
    padding: 0 5vw;
    box-sizing: border-box;
    .left{
      height: 5.5vh;
      width: 32.9vw;
      max-width: 1264px;
      display: flex;
      align-items: center;
      img{
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }
    .page-links{
      a{
        color: #FFFFFF;
        font-size: clamp(16px, 1.25vw, 48px);
        line-height: 1.2;
        margin-left: 4vw;
        cursor: pointer;
        font-weight: bold;
      }
    }
  }
  .page-top-warp{
    margin-top: -6.25vw;
    width: 100%;
    display: flex;
    height: 70vh;
    box-sizing: border-box;
    min-height: 600px;
    align-items: center;
    position: relative;
    .left{
      padding-top: 5vh;
      width: 60%;
      background: #E60012;
      display: flex;
      flex-direction: column;
      // align-items: center;
      justify-content: center;
      height: 100%;
      padding-left: 6.25vw;
      box-sizing: border-box;
      img{
        // width: 80%;
        width: 44.17vw;
        object-fit: contain;
      }
      .title{
        font-size: clamp(32px, 3.5vw, 64px);
        line-height: 1.1;
        color: #FFFFFF;
        font-weight: bold;
        text-align: left;
        width: 80%;
        &:first-child{
          margin-bottom: 1vh;
        }
      }
      .text_1{
        width: 80%;
        text-align: left;
        font-size: clamp(18px, 2.5vw, 30px);
        line-height: 1.5;
        color:rgba(255, 255, 255, 0.7);
        font-weight: 500;
        margin-top: 48px;
        white-space: nowrap;
      }
      .text_2{
        width: 80%;
        text-align: left;
        font-size: clamp(14px, 1.5vw, 20px);
        line-height: 1.3;
        color:rgba(255, 255, 255, 0.7);
        font-weight: 400;
        margin-top: 1vh;
        white-space: nowrap;
      }
      .page_button{
        margin-top: 6vh;
        width: 80%;
        text-align: left;
        display: flex;
        align-items: center;
        .button-test, .button-pdf {
          min-width: 160px;
          padding: 0 20px;
          height: clamp(32px, 2.92vw, 56px);
          border-radius: 100px;
          background: #000000;
          color: #FFFFFF;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: clamp(12px, 0.9vw, 36px);
          font-weight: 600;
          cursor: pointer;
          margin-right: 12px;
          margin-bottom: 12px;
        }
        .button-pdf {
          background: rgba(230, 220, 200, 0.4);
          // box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.06);

        }
      }
    }
    .right{
      background: #000000 url("../common/images/qzCollege/top_bg.png") no-repeat bottom right;
      background-size: contain;
      position: relative;
      width: 40%;
      height: 100%;
      img{
        width: 30vw;
        max-width: 398px;
        width: clamp(180px, 20.7vw, 398px);
        height: auto;
        position: absolute;
        bottom: 2vh;
        right: 3vw;
      }
    }
  }
  .page-content-1{
    background: #FFFFFF;
    width: 100%;
    padding: 8vh 0;
    position: relative;
    .content-tag{
      position: absolute;
      top: 20%;
      right: 2%;
      text-align: start;
      width: 68px;
      height: 264px;
      background: #BD9F68 url("../common/images/qzCollege/content_1_icon.png") no-repeat center center;
      background-size: 32px 229px;
      z-index: 1;
    }
    h1{
      display: inline-block;
      max-width: 70%;
      font-size: clamp(32px, 2.9vw, 56px);
      line-height: 1.2;
      padding-left: 1.6em;
      color: #000;
      background: url("../common/images/qzCollege/title_logo_1.png") no-repeat top left;
      background-size: auto 1.2em;
      font-weight: bold;
    }
    .content{
      display: flex;
      align-items: center;
      justify-content: center;
      //margin-top: 5vh;
      margin: 5vh auto 0;
      max-width: 1600px;
      background: url("../common/images/qzCollege/content_1_bg.png") no-repeat right center;
      background-size: 184px 315px;
      .left{
        width: 45%;
        max-width: 740px;
        margin-right: 5vw;
        img{
          width: 100%;
          height: auto;
        }
      }
      .right{
        flex: 1;
        max-width: 690px;
        padding-top: 5vh;
        color: #000000;
        font-weight: 500;
        h3{
          // font-size: clamp(24px, 3vw, 40px);
          font-size: clamp(24px, 2.08vw, 80px);
          margin-bottom: 4vh;
          text-align: left;
          font-weight: 500;
        }
        p{
          text-align: left;
          font-size: clamp(16px, 1.25vw, 48px);
          margin-bottom: 2vh;
          line-height: 1.5;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
  .page-content-2{
    background: rgba(230, 220, 200, 0.4);
    width: 100%;
    position: relative;
    .content-tag{
      width: 68px;
      height: 264px;
      position: absolute;
      left: 5%;
      top: 0;
      background: #E60012 url("../common/images/qzCollege/content_2_icon.png") no-repeat center center;
      background-size: 32px 229px;
    }
    .content{
      display: flex;
      padding: 8vh 0;
      justify-content: center;
      max-width: 1600px;
      margin: 0 auto;
      .left{
        flex: 1;
        margin-right: 5vw;
        padding-left: 5vw;
        h3{
          font-size: clamp(24px, 2.08vw, 80px);
          font-weight: 500;
          line-height: 1.2;
          margin-bottom: 4vh;
          text-align: left;
        }
        p{
          text-align: left;
          font-size: clamp(16px, 1.8vw, 24px);
          font-weight: 500;
          line-height: 1.5;
          color: rgba(0, 0, 0, 0.6);
        ;
        }
      }
      .right{
        width: 45%;
        max-width: 704px;
        img{
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .page-content-3{
    width: 100%;
    padding: 10vh 8vw 0;
    box-sizing: border-box;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    .course-list-warp{
      // width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .title{
        color: #000000;
        font-size: clamp(28px, 2.92vw, 112px);
        font-weight: 600;
        margin-bottom: 9px;
      }
      .desc{
        color: #4E5969;
        font-size: clamp(12px, 2.5vw, 48px);
        font-weight: 500;
        margin-bottom: 40px;
      }
      .course-list{
        // width: 100%;
        position: relative;
        display: flex;
        align-items: center;
        .prev, .next{
          width: 60px;
          height: 60px;
          border-radius: 50%;
          position: absolute;
          background: #F5F5F5;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          //transition: background 0.3s ease;
          flex-shrink: 0;
          color: #4E5969;
          z-index: 10;
          &:hover:not(.disabled){
            background:#E60012;
            color: #FFFFFF;
          }
          &.disabled{
            opacity: 0.4;
            cursor: not-allowed;
          }
        }
        .prev{
          left: -92px;
        }
        .next{
          right: -92px;
        }
        .course-item-warp{
          flex: 1;
          display: flex;
          gap: 1.46vw;
          width: 69.68vw;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-behavior: smooth;
          -webkit-overflow-scrolling: touch;
          position: relative;
          .course-card-warp {
            width: 16.15vw;
            min-width: 155px;
            max-width: 620px;
            margin-right: 0;
            flex-shrink: 0;
          }
          .course-card {
            width: 100%;
            // height: 100%;
            //border-radius: 20px;
            overflow: hidden;
            background: #FFFFFF;
            display: flex;
            flex-direction: column;
            position: relative;
            &:hover{
              .course-cover .fit-img{
                transform: scale(1.1);
              }
            }
            .course-cover {
              width: 100%;
              // height: 207px;
              border-radius: 20px 20px 0 0;
              overflow: hidden;
              line-height: 0;
              .fit-img {
                transition: all 0.3s ease-in-out;
              }
            }
            .free-tag {
              position: absolute;
              width: 51px;
              height: 26px;
              background: url("@/common/images/student/ic_free.png") no-repeat center center;
              background-size: 100% 100%;
              top: 19px;
              left: 0;
              z-index: 2;
            }
            .card-content {
              flex: 1;
              position: relative;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              .course-info {
                background: #FFFFFF;
                width: 100%;
                box-sizing: border-box;
                padding: 20px 24px 28px;
                border: 1px solid #DBDBDB;
                border-radius: 0 0 20px 20px;
                border-top: none;
                text-align: left;
                .course-name {
                  font-size: clamp(16px, 1.25vw, 24px);
                  margin-bottom: 4px;
                  color: #000000E5;
                  font-weight: 500;
                  line-height: 1.2;
                }
                .course-teacher {
                  font-size: clamp(12px, 0.94vw, 18px);
                  color: #4E5969;
                }
              }
            }

            .card-footer {
              margin-top: 14px;
              .view-course-btn {
                width: 100%;
                height: 2.29vw;
                min-height: 30px;
                background: #E60012;
                color: #FFFFFF;
                border: none;
                border-radius: 24px;
                font-size: clamp(12px, 0.83vw, 16px);
                font-weight: 500;
                cursor: pointer;
                transition: background 0.3s ease;
                &:hover {
                  background: #C5111F;
                }
                &:active {
                  background: #B0121A;
                }
              }
            }
          }
          &::-webkit-scrollbar {
            display: none;
          }
          scrollbar-width: none;
        }
      }
    }
  }
  .page-content-4{
    width: 100%;
    padding: 10vh 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    .content{
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      gap: 1.25vw;
      max-width: 1600px;
      margin: 0 auto;
      img{
        width: 10.4vw;
        min-width: 100px;
        max-width: 400px;
        height: auto;
      }
    }
  }
  .page-content-5{
    width: 100%;
    padding: 80px 11.25vw;
    box-sizing: border-box;
    background: #F5F1E9;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      color: #000000;
      font-size: clamp(28px, 2.92vw, 56px);
      font-weight: 600;
      margin-bottom: 64px;
      text-align: center;
    }
    .button{
      width: 240px;
      transition: all 0.3s ease;
      text-decoration: none;
      &:hover{
        transform: translateY(-2px);
      }
    }
    .el-carousel-wrap {
      width: 100%;
      margin-bottom: 40px;
    }
  }
}

@media screen and (max-width: 1600px) {
  .page-container{

    .page-content-1,.page-content-2 {
      h1{
        font-size: clamp(32px, 2.9vw, 46px);
      }
      .content{
        transform: scale(0.8);
      }
      .content-tag {
        width: 50px;
        height: 200px;
        background-size: 24px 172px;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .page-container{
    .page-top-warp .left .page_button {
      flex-direction: column;
      align-items: flex-start;
    }
    .page-content-1 {
      .content {
        flex-direction: column;
        .left, .right {
          width: 90%;
          max-width: none;
          margin: 0 auto;
        }

        .right {
          padding-top: 5vh;

          &::after {
            right: -2.5%;
            width: 10%;
          }
        }
      }

      .content-tag {
        top: 5%;
        right: 5%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .page-container{
    .page-content-1 {
      .content-tag {
        width: 40px;
        height: 160px;
        background-size: 20px 140px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .page-container{
    .page-content-1 {
      .content-tag {
        width: 30px;
        height: 120px;
        background-size: 15px 105px;
      }

      .content {
        .right::after {
          display: none;
        }
      }
    }
  }
}
</style>